import { PUFFY } from "./puffyGlyphs";

/** The house style's small parts, shared by every intro that draws in it. */

/** Deep teal: the website's ink, and the colour of every label on a white pill. */
export const TEAL = "#0f3e4a";
/** The website's soft shadow under a pill or a tile, from `.intro-header__get-app`. */
export const tealShadow = (y: number, blur: number, a = 0.18) => `0 ${y}px ${blur}px rgba(15,62,74,${a})`;

/** Passport and ticket paper: warm white, a little darker at the foot. */
export const PAPER = "linear-gradient(165deg, #fbf8f1 0%, #f1ece0 100%)";

/** The held map behind a passport or a pass: blurred and dimmed, so what stands on it reads. */
export const blurredMap = (px: (n: number) => number, dim: number) => ({
	backdropFilter: `blur(${px(14)}px) brightness(${dim})`,
	WebkitBackdropFilter: `blur(${px(14)}px) brightness(${dim})`,
});

/** A Puffy glyph at `size`, centred on the origin. Stroke glyphs (the moon) are a 2-unit round line. */
export const Glyph = ({ name, size, color }: { name: string; size: number; color: string }) => {
	const g = PUFFY[name];
	if (!g) return null;
	return (
		<g transform={`translate(${-size / 2} ${-size / 2}) scale(${size / 32})`}>
			{g.type === "stroke" ? (
				<path d={g.d} fill="none" stroke={color} strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
			) : (
				<path d={g.d} fill={color} />
			)}
		</g>
	);
};

/**
 * The website's floating icon tile, the way a vehicle rides the route: white, rounded, a soft teal
 * shadow, the glyph in the brand colour. Centred on the origin, `size` wide; `facing` -1 mirrors the
 * glyph for a leg going west. Puffy is drawn at an angle of its own, so the glyph is never turned.
 */
export const IconTile = ({ size, glyph, color, facing = 1 }: { size: number; glyph: string; color: string; facing?: number }) => (
	<>
		<rect x={-size / 2} y={-size / 2 + size * 0.05} width={size} height={size} rx={size * 0.325} fill="rgba(15,62,74,.22)" />
		<rect x={-size / 2} y={-size / 2} width={size} height={size} rx={size * 0.325} fill="#fff" />
		<g transform={`scale(${facing} 1)`}>
			<Glyph name={glyph} size={size * 0.625} color={color} />
		</g>
	</>
);
